// extracted by mini-css-extract-plugin
export var activityContainer = "_n1-0";
export var typingIndicatorContainer = "_n1-1";
export var typingIndicatorDot = "_n1-2";
export var wave = "_n1-3";